<template>
  <PageContainer>
    <template v-slot:body>
      <Container>
        <HeadingHuge>Stickers</HeadingHuge>
        <ParagraphBody> This is a page to look at components.</ParagraphBody>
        <StickerTabs />
        <Grid
          :class="$style.spacer"
          :hasGap="true"
        >
          <GridItem :gridSpan="6">
            <Card :class="$style.cardSticker">
              <HeadingMedium>Buttons & Links</HeadingMedium>
              <ParagraphBody>
                <Button
                  text="Primary Button"
                />
              </ParagraphBody>
              <ParagraphBody>
                <Button
                  hasOutline
                  text="Secondary Button"
                  type="secondary"
                />
              </ParagraphBody>
              <ParagraphBody>
                <Button
                  hasNoBackground
                  text="No Background Button"
                />
              </ParagraphBody>
              <ParagraphBody>
                <IconButton
                  hasOutline
                  icon="delete"
                  text="Icon Button"
                  type="error"
                />
              </ParagraphBody>
              <ParagraphBody>
                <IconButton
                  hasNoBackground
                  icon="edit"
                  text="Icon Button"
                  type="error"
                />
              </ParagraphBody>
              <ParagraphBody>
                <Link
                  href="/"
                  text="Link"
                />
              </ParagraphBody>
              <ParagraphBody>
                <Link
                  href="/"
                  isExternal
                  text="External Link"
                />
              </ParagraphBody>
              <ParagraphBody>
                <ButtonAdd />
              </ParagraphBody>
              <ButtonGroup
                :class="$style.spacer"
              >
                <ButtonClose />
                <ButtonDelete />
                <ButtonEdit />
                <ButtonInfo />
              </ButtonGroup>
              <ButtonGroupSave
                :class="$style.spacer"
                :isFullWidth="false"
              />
            </Card>
          </GridItem>
          <GridItem :gridSpan="6">
            <Card :class="$style.cardSticker">
              <HeadingMedium>Inputs</HeadingMedium>
              <InputText
                v-model="inputText"
                label="Input Text"
              />
              <InputNumber
                v-model="inputNumber"
                label="Input Number"
                name="Number Field"
              />
              <InputSearch
                v-model="searchInput"
                label="Input Search"
              />
              <Select
                v-model="selectValue"
                label="Select List"
                :options="selectOptions"
              />
              <Textarea
                v-model="textValue"
                label="Text Area"
              />
            </Card>
          </GridItem>
          <GridItem :gridSpan="6">
            <Card :class="$style.cardSticker">
              <HeadingMedium>Checkboxes</HeadingMedium>
              <GridAuto :class="$style.spacer">
                <Checkbox
                  v-model="toggled"
                  label="A normal Checkbox"
                />
                <Checkbox
                  v-model="toggled1"
                  label="An empty checkbox"
                />

                <Checkbox
                  v-model="toggled2"
                  :isDisabled="true"
                  label="A disabled checkbox"
                />
                <Checkbox
                  v-model="toggled3"
                  :indeterminate="true"
                  label="Indeterminate Checkbox"
                />
              </GridAuto>
              <HeadingMedium>Toggle Switch</HeadingMedium>
              <ToggleSwitch label="Toggle Switch" />
            </Card>
          </GridItem>
          <GridItem :gridSpan="6">
            <Card :class="$style.cardSticker">
              <HeadingMedium>Radio Buttons</HeadingMedium>
              <ParagraphBody :weight="'black'">
                {{ radioOptions.radioModel }}
              </ParagraphBody>
              <RadioGroup
                v-model="radioOptions.radioModel"
                :name="radioOptions.name"
                :options="radioOptions.options"
              />
              <SegmentedButton
                v-model="radioOptions.radioModel"
                name="segmentedButton"
                :options="radioOptions.options"
              />
            </Card>
          </GridItem>
          <GridItem :gridSpan="6">
            <Card :class="$style.cardSticker">
              <HeadingMedium>Copy Wells</HeadingMedium>
              <div :class="$style.spacer">
                <CopyWell
                  label="Copy Well"
                  :value="copyWellValue"
                />
              </div>
              <div
                :class="$style.spacer"
              >
                <CopyWell
                  label="Copy Well Redacted"
                  noBorder
                  :value="copyWellValue"
                  viewableToggle
                />
              </div>
            </Card>
          </GridItem>
          <GridItem :gridSpan="6">
            <Card :class="$style.cardSticker">
              <HeadingMedium>Dropdowns</HeadingMedium>
              <DropdownActions
                buttonText="DropdownActions"
                :items="dropdownOptions"
              />
            </Card>
          </GridItem>
          <GridItem :gridSpan="6">
            <Card :class="$style.cardSticker">
              <HeadingMedium>Tooltips & Icon</HeadingMedium>
              <TooltipIcon
                icon="info"
                :isDark="true"
                text="A tooltip to give some information no one will ever read."
              />
              <div :class="$style.spacer">
                <ParagraphBody
                  :hasMargin="false"
                  weight="bold"
                >
                  Icon
                </ParagraphBody>
                <Icon icon="info" />
              </div>
              <div :class="$style.spacer">
                <ParagraphBody
                  :hasMargin="false"
                  weight="bold"
                >
                  Custom Icon
                </ParagraphBody>
                <CustomIcon>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" d="M8 16A8 8 0 118 0a8 8 0 010 16zM8 1.6a6.4 6.4 0 100 12.8A6.4 6.4 0 008 1.6zM8 7a1 1 0 011 1v3.2a1 1 0 11-2 0V8a1 1 0 011-1zm0-3a1 1 0 100 2 1 1 0 000-2z"/></svg>
                </CustomIcon>
              </div>
            </Card>
          </GridItem>
          <GridItem :gridSpan="6">
            <Card :class="$style.cardSticker">
              <HeadingMedium>Modal</HeadingMedium>
              <Button
                text="Open Modal"
                @click="openModal"
              />
              <ModalConfirmation
                hasBlur
                :showModal="showModal"
                title="Confirmation Modal"
                @cancel="closeModal"
                @close="closeModal"
                @save="closeModal"
              >
                <template v-slot:body>
                  <ParagraphBody>
                    Any changes you have made will be deleted.
                  </ParagraphBody>
                  <ParagraphBody>
                    Would you like to continue?
                  </ParagraphBody>
                </template>
              </ModalConfirmation>
            </Card>
          </GridItem>
        </Grid>
        <StickerCards />
        <StickerTypography />
      </Container>
    </template>
  </PageContainer>
</template>

<script>
import {
  Button,
  ButtonAdd,
  ButtonClose,
  ButtonDelete,
  ButtonEdit,
  ButtonGroup,
  ButtonGroupSave,
  ButtonInfo,
  Card,
  Checkbox,
  Container,
  CopyWell,
  CustomIcon,
  DropdownActions,
  Grid,
  GridAuto,
  GridItem,
  HeadingHuge,
  HeadingMedium,
  Icon,
  IconButton,
  InputNumber,
  InputSearch,
  InputText,
  Link,
  ModalConfirmation,
  PageContainer,
  ParagraphBody,
  RadioGroup,
  SegmentedButton,
  Select,
  Textarea,
  ToggleSwitch,
  TooltipIcon,
  Types,
} from '@jumpcloud/ui-components';
import StickerCards from './StickerCards.vue';
import StickerTabs from './StickerTabs.vue';
import StickerTypography from './StickerTypography.vue';

const { DropdownMenuItem } = Types;

export default {
  name: 'StickerPage',

  components: {
    Button,
    ButtonGroup,
    ButtonGroupSave,
    ButtonAdd,
    ButtonClose,
    ButtonDelete,
    ButtonEdit,
    ButtonInfo,
    Card,
    Checkbox,
    CustomIcon,
    Container,
    DropdownActions,
    CopyWell,
    Grid,
    GridAuto,
    GridItem,
    HeadingHuge,
    HeadingMedium,
    Icon,
    IconButton,
    InputNumber,
    InputSearch,
    InputText,
    Link,
    ModalConfirmation,
    PageContainer,
    ParagraphBody,
    RadioGroup,
    Select,
    SegmentedButton,
    StickerCards,
    StickerTabs,
    StickerTypography,
    Textarea,
    ToggleSwitch,
    TooltipIcon,
  },

  data() {
    return {
      copyWellValue: '535143b3-f195-46e8-94a0-d597f915d736',
      inputText: '',
      inputNumber: '',
      searchInput: '',
      textValue: '',
      selectValue: '',
      dropdownOptions: [
        DropdownMenuItem({
          click: this.dropdownAction,
          text: 'Action Item 1',
        }),
        DropdownMenuItem({
          click: this.dropdownAction,
          text: 'Action Item 2',
        }),
        DropdownMenuItem({
          separator: true,
        }),
        DropdownMenuItem({
          text: 'Link Item 1',
          href: 'https://jumpcloud.com',
        }),
        DropdownMenuItem({
          text: 'Router Link 1',
          to: '/',
        }),
      ],
      radioOptions: {
        name: 'radioGroup',
        options: [
          { label: 'Yes', value: 'yes' },
          { label: 'No', value: 'no' },
          { label: 'Maybe', value: 'maybe' },
        ],
        radioModel: 'radioModel',
        rules: 'required',
      },
      selectOptions: [
        { name: 'Molly Bloom', value: 'mbloom' },
        { name: 'Leo Bloom', value: 'lbloom' },
        { name: 'Stephen Dedalus', value: 'sdedalus' },
      ],
      showModal: false,
      toggled: true,
      toggled1: false,
      toggled2: false,
      toggled3: false,
    };
  },

  methods: {
    closeModal() {
      this.showModal = false;
    },

    dropdownAction() {
      // eslint-disable-next-line no-console
      console.log('dropwdownAction');
    },

    openModal() {
      this.showModal = true;
    },
  },
};
</script>

<style module>
.spacer {
  margin: var(--jc-spacer) 0;
}

.cardSticker {
  height: 100%;
  min-height: 12rem;
}
</style>
